import { api } from '@services';

export interface IVerifyInUseTagCategory {
  inUse: boolean;
  onlyLeft: boolean;
  assets: number;
}

const verifyInUseTagCategory = async (
  id: string,
): Promise<IVerifyInUseTagCategory> => {
  const { data: inUseData } = await api.get<IVerifyInUseTagCategory>(
    `/tagsCategory/${id}/inUse`,
  );

  return inUseData;
};

export { verifyInUseTagCategory };
